import React, {Component} from "react";
import MaintenanceUsersView from "./MaintenanceUsersView";
import {MaintenanceUsersService} from "../../../service/maintenance/users/MaintenanceUsersService";
import {Growl} from "primereact/growl";
import {Button} from "primereact/button";
import ContextMenu from "../../../components/contextMenu";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {MAINTENANCE_USERS_ROUTE, UPDATE_USER_ROUTE} from "../../../utils/constants/RoutesConstants";

export default class MaintenanceUsersContainer extends Component {
    constructor(props) {
        super(props);
        this.maintenanceUsersService = new MaintenanceUsersService();
        this.getDataUsers = this.getDataUsers.bind(this);
        this.getStatusList = this.getStatusList.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.state = {
            dataUsers: this.getDataUsers('A'),
            isLoading: true,
            exportOptions: [
                {label: "Excel", action: this.exportExcel},
            ],
            statusList: this.getStatusList(),
            statusObj: "",
            selectedUsers: [],
            catInstitutionFilter: [],
        };

        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.onSelectionChangeTable = this.onSelectionChangeTable.bind(this);
        this.searchUsers = this.searchUsers.bind(this);
        this.generatePassword = this.generatePassword.bind(this);
        this.redirectAddUser = this.redirectAddUser.bind(this);
        this.redirectEditUser = this.redirectEditUser.bind(this);
        this.validateSelectedItems = this.validateSelectedItems.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.maintenanceUsersActionTemplate = this.maintenanceUsersActionTemplate.bind(this);
        this.loading = this.loading.bind(this);
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    getStatusList() {
        this.loading(true);
        this.maintenanceUsersService.getStatusList()
            .then(dataStatus => {
                this.setState({
                    statusList: dataStatus,
                    statusObj: dataStatus ? dataStatus[0] : "",
                    isLoading: false,
                })
            })
    }

    getDataUsers(status, institutionId) {
        this.loading(true);
        return this.maintenanceUsersService.getDataUsers(status, institutionId)
            .then(dataUsers => {
                this.setState({
                    dataUsers: dataUsers,
                    isLoading: false
                });
            })
    }

    /**
     * Función que exporta lo que se encuentra en la tabla a un documento de
     * excel. Para ello, hace una petición al back por medio de
     * MaintenanceUsersService.
     */
    exportExcel() {
        this.loading(true);
        let status = this.state.statusObj.idStatus;

        let institutionId = this.state.catInstitutionFilter.idInstitucion !== undefined
            ? this.state.catInstitutionFilter.idInstitucion
            : undefined;

        return this.maintenanceUsersService.exportMaintenanceUsers(status, institutionId)
            .then(response => {
                this.setState({isLoading: false})
            });
    }

    /**
     * Función que maneja el cambio en el dropdown de cuenta
     * se guarda la opción elegida en una variable del estado
     * @param event Evento que trae el valor que se eligió.
     */
    onChangeFilter(event) {
        const {name, value} = event.target;
        this.setState({
                [name]: value,
            },
        );
    }

    onSelectionChangeTable(event) {
        this.setState({selectedUsers: event.value,})
    }

    searchUsers() {
        let status = (this.state.statusObj === null || this.state.statusObj === '') ?
            "A" : this.state.statusObj.idStatus;

        let institutionId = this.state.catInstitutionFilter.idInstitucion !== undefined
            ? this.state.catInstitutionFilter.idInstitucion
            : undefined;

        this.setState({
            dataPositions: this.getDataUsers(status, institutionId),
        })
    }

    clearFilters() {
        let statusListAux = this.state.statusList;
        this.setState({
            statusObj: statusListAux[0],
            catInstitutionFilter: [],
        })
    }

    generatePassword() {
        this.loading(true);
        let usersString = "";
        this.state.selectedUsers.forEach(user => {
            usersString = usersString.concat("-" + user.usuario + "|" + user.nombreCorto)
        });
        this.maintenanceUsersService.generatePasswords(usersString.substring(1))
            .then(res => {
                this.growl.show({
                    severity: 'success', summary: 'Éxito.',
                    detail: res.message
                });
                this.setState({
                    selectedUsers: [],
                    isLoading: false,
                })
            })
    }

    validateSelectedItems() {
        if (this.state.selectedUsers && this.state.selectedUsers.length > 0) {
            if (this.confirmationRef) {
                this.confirmationRef.openConfirmationMessage();
            }
        } else {
            this.growl.show({
                severity: 'error',
                summary: 'Error.',
                detail: 'Favor de seleccionar al menos un registro.'
            });
        }
    }

    /**
     * Función que redirecciona a la pantalla de editar
     */
    redirectAddUser() {
        this.props.history.push({
            pathname: UPDATE_USER_ROUTE,
            state: {
                returnPath: MAINTENANCE_USERS_ROUTE,
                newUser: true,
                dataUsers: this.state.dataUsers,
            },
        });
    }

    /**
     * Función que redirecciona a la pantalla de editar
     */
    redirectEditUser(rowData) {
        this.props.history.push({
            pathname: UPDATE_USER_ROUTE,
            state: {
                returnPath: MAINTENANCE_USERS_ROUTE,
                newUser: false,
                selectedUser: rowData,
            },
        });
    }

    maintenanceUsersActionTemplate(rowData, column) {
        return (
            <Button label="Editar"
                    onClick={() => this.redirectEditUser(rowData)}
            />
        );
    }

    render() {
        let exportMenu =
            <div>
                <ConfirmationMessage
                    legend="¿Está seguro que desea generar los passwords de los usuarios seleccionados?"
                    action={this.generatePassword}
                    invisible={true}
                    ref={this.setConfirmationRef}/>
                <Button label="Agregar" className="p-button-secondary"
                        onClick={this.redirectAddUser}
                />&nbsp;
                <Button label="Generar Password" className="p-button-secondary"
                        onClick={this.validateSelectedItems}/>&nbsp;
                <ContextMenu menuOptions={this.state.exportOptions} isButton={true}
                             label="Exportar"/>
            </div>;

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {dataUsers, isLoading, statusList, statusObj, selectedUsers} = this.state;

        return <MaintenanceUsersView
            loading={this.loading}
            dataUsers={dataUsers}
            messagesGrowl={messagesGrowl}
            exportMenu={exportMenu}
            statusList={statusList}
            statusObj={statusObj}
            selectedUsers={selectedUsers}
            maintenanceUsersActionTemplate={this.maintenanceUsersActionTemplate}
            onChangeFilter={this.onChangeFilter}
            onSelectionChangeTable={this.onSelectionChangeTable}
            searchUsers={this.searchUsers}
            clearFilters={this.clearFilters}
            isLoading={isLoading}
            catInstitutionFilter={this.state.catInstitutionFilter}
        />
    }
};